export class WorkingPiperingModel {
    _id: string;
    id: number;
    pipeToPiperingId: number;
    _pipeToPiperingId: string;
    piperingId: number;
    _piperingId: string;
    piperingName: string;

    constructor(_id = null,
        id = null,
        pipeToPiperingId = null,
        _pipeToPiperingId = null,
        piperingId = null,
        _piperingId = null,
        piperingName = null,
    ) {
            this._id = _id;
            this.id = id;
            this.pipeToPiperingId = pipeToPiperingId;
            this._pipeToPiperingId = _pipeToPiperingId;
            this.piperingId = piperingId;
            this._piperingId = _piperingId;
            this.piperingName = piperingName;
    }
}
